import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../common/layout/header'; 
import Footer from '../common/layout/footer';
import { http } from '../helper'; 
import { BaseUrl } from '../common/config';
import CommonAlert from '../common/Commonalert';
import Sidebar from '../common/sidebar';
import ShowAlert from '../common/Showalert';
import { menuPermissions } from '../account/menupermissions';
import { canAction } from '../common/permissionhelper';
const MODULE = 'manage_roles';
const EditRoles = () => {
  // Permission checks
  const canEdit = canAction(MODULE, 'edit');
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [roleName, setRoleName] = useState('');
  const [preroleName, setPreroleName] = useState('');
  const [roleList, setRoleList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPermissions, setSelectedPermissions] = useState([]); // main modules
  const [selectedSubPermissions, setSelectedSubPermissions] = useState({}); // sub toggles
    const [errors, setErrors] = useState({});
    const [alertPopup,setAlertPopup] = useState(false);
    const [alertMessage,setAlertMessage] = useState([]);
    const [alerterrorPopup,setAlertErrorPopup] = useState(false);
    const [alerterrMessage,setAlerterrMessage] = useState([]);
    
    const params = useParams();
    if(!sessionStorage.getItem("isLoggedIn"))
        window.location.href = '/';
  useEffect(() => {
    // Fetch role details
    const fetchPermissions = async () => {
      try {
        let URL = BaseUrl +  `admin/getRole/${params.id}`;
        const response = await http.get(URL);
        const data = response.data.data;

        setRoleName(data.roleName);
        setPreroleName(data.roleName);

        // split main and sub-permissions
        const mainPerms = [];
        const subPerms = {};
        data.permissions.forEach(p => {
          if (p.includes('.')) {
            const [main, sub] = p.split('.');
            if (!subPerms[main]) subPerms[main] = [];
            subPerms[main].push(p);
          } else {
            mainPerms.push(p);
          }
        });

        setSelectedPermissions(mainPerms);
        setSelectedSubPermissions(subPerms);
        setIsLoading(false);

      } catch (error) {
        console.error('Error fetching permissions:', error);
      }

      // fetch role list
      try {
        let URL1 = BaseUrl + `admin/getRoles/`;
        const response = await http.get(URL1);
        setRoleList(response.data.data || []);
      } catch(err) {
        console.log(err);
      }
    };
    fetchPermissions();
  }, []);

  const toggleModule = (moduleValue, checked) => {
    if (checked) {
      setSelectedPermissions(prev => Array.from(new Set([...prev, moduleValue])));
      setSelectedSubPermissions(prev => {
        if (prev[moduleValue] && prev[moduleValue].length) return prev; // keep existing
        const defaultSubs = menuPermissions.find(m => m.value === moduleValue)?.subPermissions?.filter(s => s.default).map(s => s.value) || [];
        return { ...prev, [moduleValue]: defaultSubs };
      });
      setErrors(prev => ({ ...prev, permissions: '' }));
    } else {
      setSelectedPermissions(prev => prev.filter(p => p !== moduleValue));
      setSelectedSubPermissions(prev => {
        const copy = { ...prev };
        delete copy[moduleValue];
        return copy;
      });
    }
  };

  const toggleSubPermission = (moduleValue, subValue, checked) => {
    setSelectedSubPermissions(prev => {
      const curr = new Set(prev[moduleValue] || []);
      if (checked) curr.add(subValue); else curr.delete(subValue);
      return { ...prev, [moduleValue]: Array.from(curr) };
    });
  };

  const formvalidation = () => {
    const newErrors = {};
    let isValid = true;

    if (roleName.trim() === '') {
      newErrors.roleName = "Role Name is Required";
      isValid = false;
    }
    if (selectedPermissions.length === 0) {
      newErrors.permissions = "At least one permission must be selected";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const btnsubmit = async (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    if (!formvalidation()) return;

    // Build payload: main + selected sub-permissions only if main is selected
    let permissions = [];
    selectedPermissions.forEach(mod => {
      permissions.push(mod);
      const subs = selectedSubPermissions[mod] || [];
      permissions = permissions.concat(subs);
    });
    permissions = Array.from(new Set(permissions)); // dedupe

    const payload = { id: params.id, roleName, permissions };

    // check duplicate role name
    const isFound = preroleName.toLowerCase() !== roleName.toLowerCase() && roleList.some(el => el.roleName.toLowerCase() === roleName.toLowerCase());
    if (isFound) {
      setAlertErrorPopup(true);
      setAlerterrMessage('This Role Name has already been added');
      return;
    }

    try {
      setIsLoading(true);
      const URL = BaseUrl + "admin/editRole";
      const response = await http.put(URL, payload);
      if (response.data.success === true) {
        setAlertPopup(true);
        setAlertMessage('Roles and Permissions have been updated successfully');
      } else {
        setAlertErrorPopup(true);
        setAlerterrMessage(response.data.message || 'Failed to update role');
      }
    } catch(err) {
      console.log(err);
      setAlertErrorPopup(true);
      setAlerterrMessage('Server error while updating role');
    } finally {
      setIsLoading(false);
    }
  };

  const routeChange = () => { window.location.href = `/role/`; }

  return (
    
    <section className="dashboard-block">
      {alerterrorPopup && (<ShowAlert title='Alert' message={alerterrMessage}/> )}
      {alertPopup && (<CommonAlert title='Alert' message={alertMessage}/> )}

      <Sidebar />
      <div className="dash-left">
        <Header/>
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{canEdit ? 'Edit Role and Permissions' : 'View Role and Permissions'}</h1>
            <div className="right-table-outer-wrap">
              <div className='form-field freeproduct-fieldset addroles-fieldset form-container-xs'>
                <form className='client-detail-form' onSubmit={btnsubmit}>
                  <div className='input-field'>
                    <label>Role Name</label>
                    <input
                      type='text'
                      value={roleName}
                      onChange={(e) => { setRoleName(e.target.value); setErrors(prev => ({...prev, roleName:''})); }}
                      readOnly={isReadOnly}
                    />
                    {errors.roleName && <div className="error-msg">{errors.roleName}</div>}
                  </div>

                  <div className='input-field'>
                    <label>Permissions</label>
                    <div className='custom_check-box'>
                    {menuPermissions
                      .filter(module => !isReadOnly || selectedPermissions.includes(module.value)) // show only permitted modules in read-only
                      .map((module, index) => {
                        const modVal = module.value;
                        const moduleChecked = selectedPermissions.includes(modVal);
                        const subSelected = selectedSubPermissions[modVal] || [];
                        // Determine which sub-permissions to show
                        const subsToShow = isReadOnly 
                          ? module.subPermissions?.filter(sub => subSelected.includes(sub.value)) || []
                          : module.subPermissions || [];
                        return (
                          <div className='check-box' key={modVal}>
                            <div >
                              <input
                                id={`chkbox${index}`}
                                type="checkbox"
                                value={modVal}
                                checked={moduleChecked}
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  toggleModule(modVal, e.target.checked);
                                }}
                              />
                              <label htmlFor={`chkbox${index}`}>{module.name}</label>
                            </div>
                            {/* Render sub-permissions only if there are any to show */}
                            {moduleChecked && subsToShow.length > 0 && (
                              <div className='rolls-action-bx'>
                                <div className="switch-group" style={{display:'flex', gap:'12px', flexWrap:'wrap'}}>
                                  {subsToShow.map(sub => {
                                    const subChecked = subSelected.includes(sub.value);
                                    //const isViewToggle = ["view", "refresh"].includes(sub.name.toLowerCase());
                                    return (
                                      <div className="switch-item" key={sub.value} style={{display:'flex', alignItems:'center', gap:'6px'}}>
                                        <span className="switch-label">{sub.name}</span>
                                        <label className="switch switch-ios">
                                          <input
                                            type="checkbox"
                                            checked={subChecked}
                                            onChange={(e) => {
                                              if (isReadOnly) return;
                                              //if (!isViewToggle) {
                                                toggleSubPermission(modVal, sub.value, e.target.checked);
                                              //}
                                            }}
                                          />
                                          <span className="slider-ios"></span>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                    {errors.permissions && <p className="error-msg">{errors.permissions}</p>}
                  </div>

                  <div className='btnfield' style={{marginTop:'16px'}}>
                    {canEdit && <button type="submit" disabled={isLoading}>Update Role</button>}
                    &nbsp;&nbsp;&nbsp;
                    <button type="button" onClick={routeChange}>Cancel</button>
                  </div>

                </form>
              </div>
            </div>
          </div>

          <Footer/>
        </section>
       
            </div>
          
        </section>
  )
}
export default EditRoles